import React, { useState } from 'react'
import {
    ActionButton,
    Button,
    ButtonGroup,
    Content,
    Dialog,
    DialogTrigger,
    Divider,
    Heading,
    Form,
    TextField,
    TextArea,
    ProgressCircle,
} from '@adobe/react-spectrum';
import Edit from '@spectrum-icons/workflow/Edit';

const EditCustomPdcTrigger = ({ apiCallbackHandler, pdcContent, localizeStrings }) => {
    const [title, setTitle] = useState(pdcContent.title);
    const [message, setMessage] = useState(pdcContent.message);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');
    
    const validationPassed = title.trim() !== '' && message.trim() !== '';
    
    const handleUpdate = async (close) => {
        if (!validationPassed) {
            setError(localizeStrings['validation_error'] || 'Title and message are required');
            return;
        }
        
        setIsLoading(true);
        setError('');
        
        try {
            const result = await apiCallbackHandler({
                ...pdcContent,
                title,
                message
            });
            
            if (result.success) {
                close();
            } else {
                setError(localizeStrings['update_error'] || 'Failed to update content');
            }
        } catch (err) {
            setError(localizeStrings['update_error'] || 'Failed to update content');
            console.error(err);
        } finally {
            setIsLoading(false);
        }
    };
    
    return (
        <DialogTrigger>
            <ActionButton UNSAFE_style={{ border: 'none', height: '12px', width: '12px', background: 'transparent', cursor: 'pointer', marginRight: '8px' }} >
                <Edit />
            </ActionButton>
            {
                (close) => (
                    <Dialog>
                        <Heading>{localizeStrings['edit_pdc_title'] || 'Edit Content'}</Heading>
                        <Divider />
                        <Content>
                            <Form width={'100%'}>
                                <TextField 
                                    label={localizeStrings['category_text'] || 'Title'} 
                                    value={title} 
                                    onChange={setTitle} 
                                    width="100%" 
                                />
                                <TextArea 
                                    label={localizeStrings['content_text'] || 'Message'} 
                                    value={message} 
                                    onChange={setMessage} 
                                    width="100%" 
                                />
                                {error && <div style={{ color: 'red', marginTop: '8px' }}>{error}</div>}
                            </Form>
                        </Content>
                        <ButtonGroup>
                            <Button 
                                variant="secondary" 
                                UNSAFE_style={{ border: '2px solid #4B4B4B', cursor: 'pointer'}} 
                                onPress={close}
                            >
                                {localizeStrings['cancel_text'] || 'Cancel'}
                            </Button>
                            <Button 
                                variant="primary" 
                                UNSAFE_style={{ cursor: 'pointer'}}
                                onPress={() => handleUpdate(close)}
                                isDisabled={!validationPassed || isLoading}
                            >
                                {isLoading ? <ProgressCircle size="S" aria-label="Saving..." isIndeterminate /> : localizeStrings['save_text'] || 'Save'}
                            </Button>
                        </ButtonGroup>
                    </Dialog>
                )
            }
        </DialogTrigger>
    )
}

export default React.memo(EditCustomPdcTrigger); 